import { AppSpan, AppText, CustomContainer, FlexRow } from "src/style"
import { ReactComponent as TotalCustomersIcon } from 'src/assets/img/total-customers.svg'
import { ReactComponent as VerifiedCustomersIcon } from 'src/assets/img/verified-customers.svg'
import { ReactComponent as UnverifiedCustomersIcon } from 'src/assets/img/unverified-customers.svg'
import { ReactComponent as BlacklistedCustomersIcon } from 'src/assets/img/blacklisted-customers.svg'


export const CustomersCount: React.FC<any> = ({data}) => {
    return (
        <FlexRow gap='1' topMargin='2' className='customer-count-wrapper'>
            <CustomContainer
                width='25' sizeUnit='%' height='12.5' radius='0.4'
                borderColor='#E2E8F0' padding='1.5'
                className='customer-count'
            >
                <TotalCustomersIcon />
                <AppText color='#718096' textSize='1' fontWeight='600' topMargin='1.5'>TOTAL CUSTOMERS</AppText>
                <AppSpan textSize='2' color='#718096' fontWeight='600'>{data?.totalCustomers}</AppSpan>
            </CustomContainer>
            <CustomContainer
                width='25' sizeUnit='%' height='12.5' radius='0.4'
                borderColor='#E2E8F0' padding='1.5'
                className='customer-count'
            >
                <VerifiedCustomersIcon />
                <AppText color='#718096' textSize='1' fontWeight='600' topMargin='1.5'>VERIFIED CUSTOMERS</AppText>
                <AppSpan textSize='2' color='#718096' fontWeight='600'>{data?.verifiedCustomers}</AppSpan>
            </CustomContainer>
            <CustomContainer
                width='25' sizeUnit='%' height='12.5' radius='0.4'
                borderColor='#E2E8F0' padding='1.5'
                className='customer-count'
            >
                <UnverifiedCustomersIcon />
                <AppText color='#718096' textSize='1' fontWeight='600' topMargin='1.5'>UNVERIFIED CUSTOMERS</AppText>
                <AppSpan textSize='2' color='#718096' fontWeight='600'>{data?.unverifiedCustomers}</AppSpan>
            </CustomContainer>
            <CustomContainer
                width='25' sizeUnit='%' height='12.5' radius='0.4'
                borderColor='#E2E8F0' padding='1.5'
                className='customer-count'
            >
                <BlacklistedCustomersIcon />
                <AppText color='#718096' textSize='1' fontWeight='600' topMargin='1.5'>BLACKLISTED CUSTOMERS</AppText>
                <AppSpan textSize='2' color='#718096' fontWeight='600'>{data?.blackListedCustomers}</AppSpan>
            </CustomContainer>
        </FlexRow>
    )
}